import { ChangeEvent, useState } from "react";
import { useTranslation } from 'react-i18next';

interface ConfigurationModalProps{
    modalID: string;
    items: {name:string};
    handleSaveConfiguration: (item:any) => void;
}
export const ConfigurationModal = ({
    modalID,
    items,
    handleSaveConfiguration
}:ConfigurationModalProps) => {
    const [inputs, setInputs] = useState(items);
    const { t } = useTranslation('toolsApps');

    const handleChange = (event:ChangeEvent<HTMLInputElement>) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs({...inputs,[name]:value});
    };
    const handleSubmit = () => {
        handleSaveConfiguration(inputs);
    };

    return(
        <div className="modal fade" id={modalID} tabIndex={-1} aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header d-flex justify-content-center">
                        <h1 className="modal-title fs-3">{t('ocr.configuration')}</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="row g-2 mb-1">
                            <div className={'input-group mt-1 mb-2'}>
                                {/* <span className={'input-group-text'}>Straße</span>
                                <input 
                                    type="text" 
                                    className={'form-control border'}
                                    placeholder= 'Name'
                                    value={inputs.name}
                                    name='name'
                                    aria-label="name" 
                                    onChange={handleChange}
                                /> */}
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-info p-1" onClick={() => handleSubmit()} data-bs-dismiss="modal">{t('ocr.saveConfig')}</button>
                    </div>
                </div>
            </div>
        </div>
    )
}